import { DisplayMoney } from '@tock/money';
import { IconButton } from 'omakase';
import { IconClose } from 'ui/icons';
import { IconCrossLarge } from '@tock/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import BaseComponent from '@tock/shared/components/BaseComponent';

interface Props {
  giftCardDetails: {
    number: string;
    amountCents: number;
  };
  onRemove(cardNumber: string): void;
}

export default class RemoveGiftCard extends BaseComponent<Props> {
  handleRemove() {
    const { onRemove, giftCardDetails } = this.props;

    onRemove(giftCardDetails.number);
  }

  render() {
    const { giftCardDetails } = this.props;

    return (
      <div className="GiftCard-remove">
        <span className="GiftCard-number">Gift card: {giftCardDetails.number}</span>
        <span className="GiftCard-amount">
          <DisplayMoney amount={giftCardDetails.amountCents} />
        </span>
        <span className="GiftCard-removeButton">
          <IconButton variant="ghost" size="small" aria-label="delete" onClick={this.handleRemove}>
            <IconMigrationUtil
              legacyIcon={<IconClose aria-hidden="true" role="presentation" />}
              newIcon={<IconCrossLarge aria-hidden="true" role="presentation" />}
            />
          </IconButton>
        </span>
      </div>
    );
  }
}
